// Lib
import * as React from "react";
// Components
import { Skeleton, SkeletonItem } from "@fluentui/react-components";
// Styles
import { useTaskBoardViewPlaceHolderStyles } from "./TaskBoardViewPlaceHolder.styles";
// Utilities
import { customizeStyles } from "@ms/planner-generic-controls/lib/local/utilities/StyleUtilities";
/**
 * TaskBoardColumnShimmer component to show a shimmer effect for a task board column.
 */ export function TaskBoardColumnShimmer(props) {
    const { numberOfTasks, showAddTaskButtonShimmer, classNames } = props;
    const shimmers = [];
    // creating taskCardshimmer elements with the count parameter to show the number of TaskCards in the column
    for(let i = 0; i < numberOfTasks; i += 1){
        shimmers.push(/*#__PURE__*/ React.createElement(SkeletonItem, {
            key: i,
            className: classNames.taskCardShimmer
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.columnShimmer
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        appearance: "translucent"
    }, /*#__PURE__*/ React.createElement(SkeletonItem, {
        className: classNames.columnHeaderShimmer
    })), showAddTaskButtonShimmer && /*#__PURE__*/ React.createElement(Skeleton, {
        appearance: "translucent"
    }, /*#__PURE__*/ React.createElement(SkeletonItem, {
        className: classNames.addTaskShimmer
    })), numberOfTasks > 0 ? /*#__PURE__*/ React.createElement(Skeleton, {
        appearance: "translucent"
    }, shimmers) : null);
}
/**
 * TaskBoardViewPlaceHolder component to show a placeholder for the task board view.
 */ export function TaskBoardViewPlaceHolder(props) {
    const { showAddTaskButtonShimmer, numberOfTaskCardsPerColumn, stylesOverride } = props;
    const classNames = customizeStyles(useTaskBoardViewPlaceHolderStyles(), stylesOverride);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.root
    }, numberOfTaskCardsPerColumn.map((count, index)=>/*#__PURE__*/ React.createElement(TaskBoardColumnShimmer, {
            key: index,
            numberOfTasks: count,
            showAddTaskButtonShimmer: showAddTaskButtonShimmer,
            classNames: classNames
        })));
}
